/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Admin Users API
 * Admin bounded-context contract for user aggregate and owned task entity.
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateUserRequest,
  ListUsersParams,
  PaginatedUserResult,
  UpdateUserRequest,
  User,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getListUsersUrl = (params: ListUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["roles", "departments"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/users?${stringifiedParams}`
    : `/api/admin/users`;
};

/**
 * Retrieve a paginated list of users with support for:
 * - Full-text search (name/email)
 * - Role filtering (single or multiple)
 * - Date range filtering (by createdAt)
 * - Department filtering (single or multiple)
 * - Seniority range filtering
 * - Server-side sorting
 * - Pagination
 * @summary List users with optional filtering, sorting, and pagination
 */
export const listUsers = async (
  params: ListUsersParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedUserResult> => {
  return customFetch<PaginatedUserResult>(getListUsersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCreateUserUrl = () => {
  return `/api/admin/users`;
};

/**
 * Create a new user with minimal required fields.
 * The user will be initialized with default values for:
 * - isActive: true
 * - bio: null
 * - onboardingProgress: 0
 * - taskCompletionRate: 0
 * - seniority: 1
 * - loginCount: 0
 * - lastLoginAt: current timestamp
 * - tasks: empty array
 * - image: deterministically generated based on user ID
 * - department: deterministically generated based on user ID
 * @summary Create a new user
 */
export const createUser = async (
  createUserRequest: CreateUserRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<User> => {
  return customFetch<User>(getCreateUserUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(createUserRequest),
  });
};

export const getGetUserUrl = (userId: string) => {
  return `/api/admin/users/${userId}`;
};

/**
 * Retrieve a user by ID including all their associated tasks.
 * Throws 404 if the user does not exist.
 * @summary Get a single user by ID
 */
export const getUser = async (
  userId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<User> => {
  return customFetch<User>(getGetUserUrl(userId), {
    ...options,
    method: "GET",
  });
};

export const getUpdateUserUrl = (userId: string) => {
  return `/api/admin/users/${userId}`;
};

/**
 * Partially update a user's mutable fields.
 * Only the provided fields will be updated; unspecified fields remain unchanged.
 * Immutable fields (id, createdAt) cannot be updated.
 * @summary Update a user
 */
export const updateUser = async (
  userId: string,
  updateUserRequest: UpdateUserRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<User> => {
  return customFetch<User>(getUpdateUserUrl(userId), {
    ...options,
    method: "PATCH",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateUserRequest),
  });
};

export const getDeleteUserUrl = (userId: string) => {
  return `/api/admin/users/${userId}`;
};

/**
 * Delete a user by ID. All associated tasks are also deleted.
 * Throws 404 if the user does not exist.
 * @summary Delete a user
 */
export const deleteUser = async (
  userId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteUserUrl(userId), {
    ...options,
    method: "DELETE",
  });
};
